import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DevToolsBubble } from 'react-native-react-query-devtools';

import { useIsWeb } from '@hooks/useIsWeb';
import { useState } from 'react';

interface Props {
  children?: React.ReactNode;
}
function CustomQueryClientProvider({ children }: Props): React.ReactNode {
  const isWeb = useIsWeb();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error): void => {
            console.error(`Something went wrong: ${error.message}`);
          },
        }),
        mutationCache: new MutationCache({
          onError: (error): void => {
            console.error(`Something went wrong: ${error.message}`);
          },
        }),
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {__DEV__ &&
        (isWeb ? (
          <ReactQueryDevtools initialIsOpen={false} />
        ) : (
          <DevToolsBubble queryClient={queryClient} />
        ))}
    </QueryClientProvider>
  );
}

export default CustomQueryClientProvider;
